(function () {
    function FilteredTable(elem) {
        var rows;
        this.table = elem;
        rows = Array.prototype.slice.call(this.table.getElementsByTagName("tr"))
        this.headers = rows[0].querySelectorAll("*");
        this.rows = rows.splice(1);

        var inputSelector = elem.getAttribute("data-filter-input");
        this.input = document.querySelector(inputSelector);
    }

    FilteredTable.prototype.init = function () {
        var labels, cells, i, j, k;
        labels = [];

        this.search = this.search.bind(this);

        if (this.input) {
            this.input.addEventListener("keyup", this.search);
        }

        // get label form inner text of header        
        for (i = 0; i < this.headers.length; i++) {
            labels.push(this.headers[i].innerText);
        }

        // set label to inner text of header
        for (j = 0; j < this.rows.length; j++) {
            cells = this.rows[j].querySelectorAll("td");
            for (k = 0; k < cells.length; k++) {
                cells[k].setAttribute("data-label", labels[k]);
            }
        }
    }

    FilteredTable.prototype.search = function () {
        var filters, filter, cells, tr, td, i, j, k,
            matchesAll = true, matchesOne = false;

        filters = this.input.value.trim().length > 0 ?
            this.input.value.toUpperCase().trim().split(" ") :
            [];

        for (i = 0; i < this.rows.length; i++) {
            tr = this.rows[i];
            for (j = 0; j < filters.length; j++) {
                filter = filters[j];
                matchesAll = tr.innerText.toUpperCase().indexOf(filter) > -1;
                if (!matchesAll) {
                    break;
                }
            }
            if (matchesAll) {
                tr.style.display = "";
                cells = this.rows[i].querySelectorAll("td");

                for (k = 0; k < cells.length; k++) {
                    td = cells[k];
                    matchesOne = false;
                    for (j = 0; j < filters.length; j++) {
                        filter = filters[j];
                        matchesOne = matchesAllFilters = td.innerText.toUpperCase().indexOf(filter) > -1;
                        if (matchesOne) {
                            break;
                        }
                    }
                    if (matchesOne) {
                        td.style.color = "#fff";
                        td.style.background = "green";
                    } else {
                        td.style.color = "";
                        td.style.background = "";
                    }
                }
            } else {
                tr.style.display = "none";
            }
        }
    }

    function pad(num, size) {
        var result = num.toString();
        while (result.length < size) {
            result = "0" + result;
        }
        return result;
    }

    var dayNames = [
        "So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"
    ];

    function formatDate(strDate) {
        var date = new Date(strDate);
        if (isNaN(date.getTime())) {
            return null;
        }
        var dayIndex = date.getDay();
        var day = pad(date.getDate(), 2);
        var month = pad(date.getMonth() + 1, 2);
        var year = date.getFullYear();

        return dayNames[dayIndex] + ", " + day + "." + month + "." + year;
    }

    function init() {
        var i, j, tables, table, rows, cells;
        tables = document.querySelectorAll("table[data-filter-input]");
        for (i = 0; i < tables.length; i++) {
            table = new FilteredTable(tables[i])
            table.init();
            rows = table.rows;
            for (j = 0; j < rows.length; j++) {
                cells = rows[j].getElementsByTagName("td");
                td = cells[0];
                date = formatDate(td.innerText);
                if (date) {
                    td.innerText = date;
                }
            }
        }
    };
    init();
} ());